const groupKey = (record) => JSON.stringify([record.generation, record.frame.task_id]);
/** Resolved or withdrawn requests are reclaimable; task completion and suspension do not release them. */
export function sessionRetentionUnits(records) {
    const interactions = new Map();
    const ordinary = [];
    const lifecycle = new Map();
    const generation = records.at(-1)?.generation;
    let nativeIdentity;
    let capabilityRecord;
    let runtimeRecord;
    let hasCapabilities = false;
    const identities = new Map();
    for (const record of records) {
        const event = record.resolution ?? record.frame.event;
        const group = groupKey(record);
        if (event.type === 'runtime_updated')
            identities.set(record.generation, JSON.stringify([event.providerId, event.runtimeInfo.sessionId]));
        if (event.type === 'agent_snapshot') {
            const identity = JSON.stringify([event.payload.providerId, event.payload.runtimeInfo.sessionId]);
            identities.set(record.generation, identity);
            const confirmed = new Set(event.payload.pendingInteractions.map(request => request.requestId));
            for (const [key, unit] of interactions) {
                const [requestGeneration, interactionGeneration, requestId] = JSON.parse(key);
                if (unit.unresolved && (unit.nativeIdentity === identity || !unit.nativeIdentity && requestGeneration === record.generation) && (requestGeneration !== record.generation || interactionGeneration !== (record.interactionGeneration ?? null) || !confirmed.has(requestId) || event.payload.status === 'closed' || event.payload.runtimeInfo.status === 'closed'))
                    unit.terminal = record;
            }
        }
        if (record.generation === generation && event.type === 'agent_snapshot') {
            runtimeRecord = record;
            capabilityRecord = record;
            hasCapabilities = true;
            nativeIdentity = JSON.stringify([event.payload.providerId, event.payload.runtimeInfo.sessionId]);
        }
        if (record.generation === generation && event.type === 'runtime_updated') {
            const identity = JSON.stringify([event.providerId, event.runtimeInfo.sessionId]);
            if (identity !== nativeIdentity)
                capabilityRecord = undefined;
            nativeIdentity = identity;
            runtimeRecord = record;
            if (record.frame.session_capabilities) {
                capabilityRecord = record;
                hasCapabilities = true;
            }
        }
        if (event.type === 'runtime_updated' && event.runtimeInfo.status === 'closed') {
            for (const unit of interactions.values()) {
                if (unit.unresolved && unit.records[0].generation === record.generation && (!unit.nativeIdentity || unit.nativeIdentity === identities.get(record.generation)))
                    unit.terminal = record;
            }
        }
        if (['turn_started', 'turn_completed', 'turn_canceled', 'turn_failed', 'runtime_updated', 'agent_snapshot'].includes(event.type))
            lifecycle.set(group, record);
        const requestId = !record.presentation?.unavailable && (event.type === 'interaction_requested' ? event.payload.request.requestId : event.type === 'interaction_resolved' ? event.payload.requestId : event.type === 'timeline' && event.item.type === 'interaction' ? event.item.request.requestId : undefined);
        if (!requestId) {
            ordinary.push(record);
            continue;
        }
        const key = JSON.stringify([record.generation, record.interactionGeneration, requestId]);
        const unit = interactions.get(key) ?? { records: [], unresolved: false, pendingToken: undefined, nativeIdentity: identities.get(record.generation) };
        unit.records.push(record);
        if (event.type === 'interaction_requested') {
            unit.unresolved = true;
            unit.pendingToken = record.id;
        }
        else if (!record.requestToken || record.requestToken === unit.pendingToken)
            unit.unresolved = false;
        interactions.set(key, unit);
    }
    const pending = [...interactions.values()].filter(unit => unit.unresolved);
    const pendingGroups = new Set(pending.map(unit => groupKey(unit.records[0])));
    const protectedLifecycle = new Set([
        ...(hasCapabilities && runtimeRecord ? [runtimeRecord] : []),
        ...(capabilityRecord ? [capabilityRecord] : []),
        ...[...lifecycle.values()].filter(record => pendingGroups.has(groupKey(record))),
        ...pending.flatMap(unit => unit.terminal ? [unit.terminal] : []),
    ].map(record => record.id));
    return [...interactions.values()].map(unit => ({ records: unit.records, protected: unit.unresolved && !unit.terminal }))
        .concat(ordinary.map(record => ({ records: [record], protected: protectedLifecycle.has(record.id) })))
        .sort((a, b) => a.records[0].ordinal - b.records[0].ordinal);
}
//# sourceMappingURL=session-retention.js.map